import React, { cloneElement } from 'react';
import { ReactComponent as IconIT } from '../assets/svg/IT.svg';
import { ReactComponent as IconAdmin } from '../assets/svg/Admin.svg';
import { ReactComponent as IconSales } from '../assets/svg/Comercial.svg';
import { ReactComponent as IconCare } from '../assets/svg/Asistencial.svg';
import { ReactComponent as IconStock } from '../assets/svg/Stock.svg';
import { ReactComponent as IconInquirie } from '../assets/svg/Consulta.svg';
import { ReactComponent as IconQuality } from '../assets/svg/Calidad.svg';
import { ReactComponent as IconEvolution } from '../assets/svg/Evolucion.svg';
import { ReactComponent as IconFee } from '../assets/svg/Honorarios.svg';
import { ReactComponent as IconClosingSales } from '../assets/svg/CierreDeVentas.svg';
import { ReactComponent as IconClinicalHistory } from '../assets/svg/HistoriaClinica.svg';
import { ReactComponent as IconDocumentation } from '../assets/svg/Documentacion.svg';
import { ReactComponent as IconProfessional } from '../assets/svg/Profesionales.svg';
import { ReactComponent as IconCrediticia } from '../assets/svg/Crediticia.svg';
import { ReactComponent as IconPriceControlAuthorization } from '../assets/svg/AutorizacionPreciosControl.svg';
import { ReactComponent as IconPriceChangeAuthorization } from '../assets/svg/AutorizacionPreciosCambio.svg';
import { ReactComponent as IconServiceCoordinator } from '../assets/svg/CoordinadorServicio.svg';
import { ReactComponent as IconLiquidacion } from '../assets/svg/Liquidacion.svg';

/**
 * Enum to get svg icons as react components. 
 * It should be used in the following way: icons[index]
 * It can be cloned with React.cloneElement in order to inject extra props such as className
 */
export const icons = {
    1: <IconIT />,
    2: <IconAdmin />,
    3: <IconSales />,
    4: <IconCare />,
    6: <IconStock />,
    7: <IconInquirie />,
    8: <IconQuality />,
    9: <IconEvolution />,
    10: <IconFee />,
    12: <IconClosingSales />,
    13: <IconClinicalHistory />,
    14: <IconDocumentation />,
    15: <IconPriceControlAuthorization />,
    16: <IconPriceChangeAuthorization />,
    17: <IconServiceCoordinator />,
    18: <IconProfessional />,
    19: <IconCrediticia />,
    20: <IconLiquidacion />

}

// Component that adds extra customization and is expected to return an icon
export const RenderIcon = ({ index = 0, className = '' }) => {
    return cloneElement(icons[index] || <></>, { className: className });
}